/* TEE UP theme — interactions */
(function(){
  "use strict";
  var TU = window.TU || {};
  var routes = TU.routes || {};

  /* ---------- money ---------- */
  function formatMoney(cents){
    var fmt = TU.moneyFormat || "${{amount}}";
    var value = "";
    var pm = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal){
      precision = (precision===undefined)?2:precision;
      thousands = thousands||",";
      decimal = decimal||".";
      var v = (cents/100).toFixed(precision);
      var parts = v.split(".");
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var centsPart = parts[1]?(decimal+parts[1]):"";
      return dollars+centsPart;
    }
    switch((fmt.match(pm)||[])[1]){
      case "amount": value=num(2); break;
      case "amount_no_decimals": value=num(0); break;
      case "amount_with_comma_separator": value=num(2,".",","); break;
      case "amount_no_decimals_with_comma_separator": value=num(0,".",","); break;
      case "amount_with_space_separator": value=num(2," ","."); break;
      case "amount_with_apostrophe_separator": value=num(2,"'","."); break;
      default: value=num(2);
    }
    return fmt.replace(pm, value);
  }
  window.TUmoney = formatMoney;

  /* ---------- toast ---------- */
  var toastEl = document.getElementById("toast"), toastT;
  function toast(msg){
    if(!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastT);
    toastT = setTimeout(function(){ toastEl.classList.remove("show"); }, 2000);
  }

  /* ---------- reveal on scroll ---------- */
  if("IntersectionObserver" in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: .1 });
    document.querySelectorAll(".r:not(.in)").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".r").forEach(function(el){ el.classList.add("in"); });
  }

  /* ---------- sticky header shadow ---------- */
  /* (border handles it; class kept for future) */

  /* ---------- menu drawer ---------- */
  var menu = document.querySelector(".menu-drawer");
  document.addEventListener("click", function(e){
    if(e.target.closest("[data-menu-open]")){ if(menu) menu.classList.add("open"); document.body.style.overflow="hidden"; }
    if(e.target.closest("[data-menu-close]")){ if(menu) menu.classList.remove("open"); document.body.style.overflow=""; }
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector(".cart-drawer");
  var overlay = document.querySelector(".cart-overlay");
  function openDrawer(){ if(!drawer) return; drawer.classList.add("open"); if(overlay) overlay.classList.add("open"); document.body.style.overflow="hidden"; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove("open"); if(overlay) overlay.classList.remove("open"); document.body.style.overflow=""; }

  document.addEventListener("click", function(e){
    if(e.target.closest("[data-cart-open]")){
      if(TU.cartType === "page"){ return; } // let link proceed
      e.preventDefault(); refreshCart(true);
    }
    if(e.target.closest("[data-cart-close]") || e.target === overlay){ closeDrawer(); }
  });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ closeDrawer(); if(menu) menu.classList.remove("open"); document.body.style.overflow=""; } });

  function setCount(n){
    document.querySelectorAll(".cart-count").forEach(function(el){
      el.textContent = n;
      el.classList.toggle("is-zero", !n);
      el.classList.add("bump"); setTimeout(function(){ el.classList.remove("bump"); }, 200);
    });
  }

  function cartImg(url, w){
    if(!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function lineRow(item){
    var img = item.image ? '<div class="cd-line__img"><img src="'+cartImg(item.image, 160)+'" alt="" loading="lazy"></div>' : '<div class="cd-line__img"></div>';
    var variant = (item.options_with_values && item.options_with_values.length && item.options_with_values[0].value !== "Default Title")
      ? '<div class="var">'+item.options_with_values.map(function(o){return o.value;}).join(" / ")+'</div>' : '';
    return ''+
    '<div class="cd-line" data-key="'+item.key+'">'+
      img+
      '<div>'+
        '<div class="nm">'+item.product_title+'</div>'+variant+
        '<div class="qty" data-key="'+item.key+'">'+
          '<button type="button" data-qd="-1" aria-label="Decrease">&minus;</button>'+
          '<input type="text" value="'+item.quantity+'" inputmode="numeric" data-qinput readonly>'+
          '<button type="button" data-qd="1" aria-label="Increase">+</button>'+
        '</div>'+
      '</div>'+
      '<div class="ln">'+formatMoney(item.final_line_price)+'</div>'+
    '</div>';
  }

  function renderDrawer(cart){
    if(!drawer) return;
    var body = drawer.querySelector("[data-cd-body]");
    var foot = drawer.querySelector("[data-cd-foot]");
    if(cart.item_count === 0){
      if(body) body.innerHTML = '<div class="cd-empty">'+(TU.strings?TU.strings.empty:"Your bag is empty")+'</div>';
      if(foot) foot.innerHTML = '<a class="btn btn--block" href="'+(routes.cart||"/cart")+'">Continue shopping</a>';
      return;
    }
    if(body) body.innerHTML = cart.items.map(lineRow).join("");
    if(foot){
      foot.innerHTML =
        '<div class="sub"><span>Subtotal</span><span>'+formatMoney(cart.total_price)+'</span></div>'+
        '<div class="ship">'+(drawer.getAttribute("data-ship")||"Shipping & taxes at checkout")+'</div>'+
        '<a class="btn btn--block" href="/checkout">Checkout</a>'+
        '<a class="btn btn--white btn--block" style="margin-top:10px" href="'+(routes.cart||"/cart")+'">View bag</a>';
    }
  }

  function refreshCart(openAfter){
    fetch((routes.cart||"/cart")+".js", { headers: { "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        setCount(cart.item_count);
        renderDrawer(cart);
        // update cart page if present
        if(document.querySelector("[data-cart-page]") && window.__cartReload){ window.__cartReload(cart); }
        if(openAfter) openDrawer();
      });
  }

  function changeLine(key, qty){
    fetch((routes.cart_change||"/cart/change")+".js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); })
      .then(function(cart){
        setCount(cart.item_count);
        renderDrawer(cart);
        if(window.__cartReload) window.__cartReload(cart);
      });
  }

  /* qty steppers (drawer + cart page + pdp) */
  document.addEventListener("click", function(e){
    var stepBtn = e.target.closest("[data-qd]");
    if(!stepBtn) return;
    var wrap = stepBtn.closest(".qty");
    var input = wrap.querySelector("input");
    var dir = parseInt(stepBtn.getAttribute("data-qd"),10);
    var key = wrap.getAttribute("data-key");
    var val = Math.max(key?0:1, (parseInt(input.value,10)||0) + dir);
    if(key){ changeLine(key, val); } else { input.value = val; }
  });

  /* ---------- add to cart (quick add on cards) ---------- */
  document.addEventListener("click", function(e){
    var add = e.target.closest("[data-add]");
    if(!add) return;
    e.preventDefault();
    var id = add.getAttribute("data-add");
    if(!id){ return; }
    add.setAttribute("disabled","");
    fetch((routes.cart_add||"/cart/add")+".js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items:[{ id: id, quantity: 1 }] })
    }).then(function(r){ return r.json(); })
      .then(function(){ toast(TU.strings?TU.strings.added:"Added to bag"); refreshCart(true); })
      .catch(function(){ toast("Could not add"); })
      .finally(function(){ add.removeAttribute("disabled"); });
  });

  /* ---------- product form ---------- */
  var pform = document.querySelector("[data-product-form]");
  if(pform){
    var productData = null;
    var dataEl = document.getElementById("ProductJSON");
    try { productData = dataEl ? JSON.parse(dataEl.textContent) : null; } catch(err){}
    var idInput = pform.querySelector('[name="id"]');
    var priceEl = document.querySelector("[data-pdp-price]");
    var addBtn = pform.querySelector("[data-add-btn]");

    function currentOptions(){
      return Array.prototype.map.call(pform.querySelectorAll("[data-opt]"), function(group){
        var checked = group.querySelector("input:checked");
        if(checked) return checked.value;
        var sel = group.querySelector("select");
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts){
      if(!productData) return null;
      return productData.variants.find(function(v){
        return v.options.every(function(o,i){ return o === opts[i]; });
      });
    }
    function updateVariant(){
      if(!productData) return;
      var v = findVariant(currentOptions());
      if(!v){
        if(addBtn){ addBtn.textContent = "Unavailable"; addBtn.setAttribute("disabled",""); }
        return;
      }
      if(idInput) idInput.value = v.id;
      if(priceEl){
        var html = '<span'+(v.compare_at_price>v.price?' class="on-sale"':'')+'>'+formatMoney(v.price)+'</span>';
        if(v.compare_at_price>v.price){ html += '<s>'+formatMoney(v.compare_at_price)+'</s>'; }
        priceEl.innerHTML = html;
      }
      if(addBtn){
        if(v.available){ addBtn.textContent = "Add to bag"; addBtn.removeAttribute("disabled"); }
        else { addBtn.textContent = (TU.strings?TU.strings.soldout:"Sold out"); addBtn.setAttribute("disabled",""); }
      }
      // swap gallery to variant image
      if(v.featured_media && v.featured_media.id){ swapGalleryTo(v.featured_media.id, v.featured_media.src); }
    }
    pform.addEventListener("change", function(e){ if(e.target.closest("[data-opt]")) updateVariant(); });

    pform.addEventListener("submit", function(e){
      e.preventDefault();
      var qtyInput = pform.querySelector(".qty input");
      var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
      var id = idInput ? idInput.value : null;
      if(!id) return;
      if(addBtn) addBtn.setAttribute("disabled","");
      fetch((routes.cart_add||"/cart/add")+".js", {
        method:"POST",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({ items:[{ id:id, quantity: qty }] })
      }).then(function(r){ return r.json(); })
        .then(function(){ toast(TU.strings?TU.strings.added:"Added to bag"); refreshCart(true); })
        .catch(function(){ toast("Could not add"); })
        .finally(function(){ if(addBtn) addBtn.removeAttribute("disabled"); });
    });
    updateVariant();
  }

  /* ---------- gallery ---------- */
  function swapGalleryTo(mediaId, srcOverride){
    var main = document.querySelector("[data-gallery-main]");
    var thumbs = document.querySelectorAll("[data-thumb]");
    if(!main && !thumbs.length) return;
    var matched = false;
    thumbs.forEach(function(t){
      if(t.getAttribute("data-media-id") === String(mediaId)){
        matched = true;
        var src = t.getAttribute("data-full");
        if(main && src){ main.innerHTML = '<img src="'+src+'" alt="">'; }
        t.setAttribute("aria-current","true");
      } else { t.removeAttribute("aria-current"); }
    });
    if(main && !matched && srcOverride){ main.innerHTML = '<img src="'+srcOverride+'" alt="">'; }
  }
  document.addEventListener("click", function(e){
    var thumb = e.target.closest("[data-thumb]");
    if(!thumb) return;
    swapGalleryTo(thumb.getAttribute("data-media-id"));
  });

  /* ---------- testimonials rotator ---------- */
  document.querySelectorAll("[data-testimonials]").forEach(function(root){
    var items = JSON.parse(root.getAttribute("data-testimonials")||"[]");
    if(items.length<2) return;
    var q = root.querySelector("[data-quote]"), by = root.querySelector("[data-by]"), dots = root.querySelector("[data-dots]");
    var i = 0;
    items.forEach(function(_,k){
      var b = document.createElement("button"); b.setAttribute("role","tab"); b.setAttribute("aria-label","Review "+(k+1));
      if(!k) b.setAttribute("aria-current","true");
      b.addEventListener("click", function(){ go(k); });
      if(dots) dots.appendChild(b);
    });
    function go(k){
      i=k;
      if(q){ q.style.opacity=0; } if(by){ by.style.opacity=0; }
      setTimeout(function(){
        if(q){ q.innerHTML = items[k].quote; q.style.transition="opacity .4s"; q.style.opacity=1; }
        if(by){ by.textContent = items[k].by; by.style.opacity=1; }
        if(dots) Array.prototype.forEach.call(dots.children, function(d,n){ n===k?d.setAttribute("aria-current","true"):d.removeAttribute("aria-current"); });
      }, 220);
    }
    setInterval(function(){ go((i+1)%items.length); }, 5200);
  });

  /* cart count is already server-rendered; drawer refreshes itself on open */
  window.TUcart = { refresh: refreshCart, open: openDrawer, close: closeDrawer, change: changeLine };
})();

  /* ---------- product tabs ---------- */
  document.addEventListener("click", function(e){
    var tab = e.target.closest("[data-tab-target]");
    if(!tab) return;
    var root = tab.closest("[data-ptabs]");
    if(!root) return;
    var id = tab.getAttribute("data-tab-target");
    root.querySelectorAll(".ptabs__tab").forEach(function(t){ t.classList.toggle("active", t === tab); });
    root.querySelectorAll(".ptabs__panel").forEach(function(p){ p.classList.toggle("active", p.id === id); });
  });

  /* ---------- hero video sound toggle ---------- */
  document.addEventListener("click", function(e){
    var btn = e.target.closest("[data-hero-mute]");
    if(!btn) return;
    var hero = btn.closest(".vhero");
    var vid = hero && hero.querySelector("video");
    if(!vid) return;
    vid.muted = !vid.muted;
    btn.classList.toggle("is-muted", vid.muted);
    if(!vid.muted){ vid.play().catch(function(){}); }
  });
